export const PROFILE_BASE_PATH = "/profile";

export const PROFILE_CHILD_PATHS = {
  HOME: "",
  LANGUAGE: "language",
  SUBSCRIPTION: "my-subscription",
  HELP_CENTRE: "help-centre-faq",
  EDIT_QUESTIONNAIRE: "edit-questionnaire",
} as const;
